import { FragmentOf, graphql, readFragment } from "gql.tada";

import ImageFragment from "./imageFragment";
import { readImageFragment } from "./readImageFragment";

const ImageConnectionFragment = graphql(
  `
    fragment ImageConnectionFragment on ImageConnection {
      edges {
        node {
          ...ImageFragment
        }
      }
    }
  `,
  [ImageFragment],
);

export const readImageConnectionFragment = (
  fragment: FragmentOf<typeof ImageConnectionFragment> | null | undefined,
) => {
  if (!fragment) return [];

  const images = readFragment(ImageConnectionFragment, fragment);

  if (!images.edges?.length) {
    return [];
  }

  return images.edges
    .map((edge) => readImageFragment(edge.node))
    .filter((image): image is NonNullable<typeof image> => image !== null);
};

export default ImageConnectionFragment;
